const icon = document.querySelector(".icon--search");
const predictiveSearch = document.getElementById("predictive-search");

icon.addEventListener("click", () => {
  if (predictiveSearch.classList.contains("open")) {
    predictiveSearch.classList.remove("open");
  } else {
    predictiveSearch.classList.add("open");
  }
});
 
for (const stars of document.querySelectorAll(".c-card-product .jdgm-widget")) {
  stars.addEventListener("click", (evt) => {
    const location = stars.closest(".c-card-link").href;
    window.location.href = location;
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const element = document.getElementById("element_visual_footer");
    if (element) {
      element.classList.add("visible");
    }


    // ** V1 CART FPD ** //
    console.log("Custom js is available.");

(function () {
  // ============================================
  // CONFIGURATION DES ZONES ET TARIFS
  // ============================================
  
  const SHIPPING_CONFIG = {
    // Seuils de livraison gratuite
    FREE_SHIPPING_THRESHOLDS: {
      FRANCE: 49,
      DOMTOM: 120
    },
    
    // Pays non desservis (afficher message "zone non desservie")
    NOT_COVERED_COUNTRIES: [
      'AC', 'BJ', 'BW', 'IO', 'BF', 'BI', 'CV', 'CF', 'TD', 'KM', 'CG', 'CD', 'CI', 'DJ',
      'EG', 'GQ', 'ER', 'SZ', 'ET', 'TF', 'GA', 'GM', 'GH', 'GN', 'GW', 'KE', 'LS', 'LR',
      'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'MA', 'MZ', 'NA', 'NE', 'NG', 'CM', 'RW', 'SH',
      'ST', 'SN', 'SC', 'SL', 'SO', 'ZA', 'SS', 'SD', 'TZ', 'TG', 'TN', 'UG', 'EH', 'ZM',
      'ZW', 'US', 'CA', 'AE'
    ],
    
    // Pays DOM-TOM
    DOMTOM_COUNTRIES: ['GF', 'GP', 'MQ', 'RE', 'YT', 'PM', 'BL', 'MF', 'WF', 'PF', 'NC'],
    
    // Pays Europe 1
    EUROPE1_COUNTRIES: ['DE', 'IT', 'PT', 'AT', 'NL', 'DK', 'SE', 'FI', 'PL', 'CZ', 'SK', 
                        'SI', 'HU', 'RO', 'BG', 'HR', 'EE', 'LV', 'LT'],
    
    // Tarifs par zone
    RATES: {
      FRANCE: [
        { name: 'Colissimo Livraison à domicile', price: 4.90 },
        { name: 'Livraison en point de retrait Mondial Relay', price: 3.90 }
      ],
      BELGIUM_LUXEMBOURG: [
        { name: 'Colissimo Europe', price: 6.90 },
        { name: 'Livraison en point de retrait Mondial Relay', price: 3.90 }
      ],
      SPAIN: [
        { name: 'Colissimo Europe', price: 6.90 },
        { name: 'Punto Pack - Livraison en point de retrait Mondial Relay', price: 3.90 }
      ],
      EUROPE1: [
        { name: 'Colissimo Europe', price: 6.90 }
      ],
      DOMTOM: [
        { name: 'Colissimo DOM-TOM', price: 19.90 }
      ],
      UK: [
        { name: 'Colissimo', price: 15.90 }
      ],
      SWITZERLAND: [
        { name: 'Colissimo', price: 9.90 }
      ],
      INTERNATIONAL: [
        { name: 'Colissimo International', price: 34.90 }
      ]
    }
  };

  // Déterminer la zone d'un pays
  function getShippingZone(countryCode) {
    if (countryCode === 'FR') return 'FRANCE';
    if (countryCode === 'BE' || countryCode === 'LU') return 'BELGIUM_LUXEMBOURG';
    if (countryCode === 'ES') return 'SPAIN';
    if (countryCode === 'GB') return 'UK';
    if (countryCode === 'CH') return 'SWITZERLAND';
    if (SHIPPING_CONFIG.DOMTOM_COUNTRIES.includes(countryCode)) return 'DOMTOM';
    if (SHIPPING_CONFIG.EUROPE1_COUNTRIES.includes(countryCode)) return 'EUROPE1';
    if (SHIPPING_CONFIG.NOT_COVERED_COUNTRIES.includes(countryCode)) return 'NOT_COVERED';
    return 'INTERNATIONAL';
  }

  // Liste des pays européens - pour les délais
  const EUROPE_COUNTRIES = [
    'FR', 'BE', 'ES', 'DE', 'IT', 'NL', 'PT', 'LU', 'IE', 'AT',
    'DK', 'SE', 'FI', 'PL', 'CZ', 'SK', 'SI', 'HU', 'RO', 'BG',
    'HR', 'EE', 'LV', 'LT', 'GR', 'CY', 'MT'
  ];

  function getLocale() {
    if (window.Shopify && Shopify.locale) {
      return Shopify.locale;
    }
    return 'en';
  }

  function getTranslations() {
    const locale = getLocale();

    const dict = {
      fr: {
        open: 'Calculer mes frais de port et délais de livraison',
        title: 'Calcul des frais de port et délais de livraison',
        country: 'Pays / région',
        calc: 'Calculer',
        loading: 'Calcul en cours...',
        missing: 'Merci de sélectionner un pays.',
        noRates: 'Aucun tarif disponible pour cette adresse.',
        notCovered: 'Zone non desservie - Nous ne livrons pas dans cette région pour le moment.',
        error: 'Impossible de calculer les frais de port pour le moment.',
        available: 'Tarifs disponibles pour votre adresse :',
        delayLabel: 'Délai estimé :',
        delayFr: '48h - 72h jours ouvrés',
        delayEu: '5 à 7 jours ouvrés',
        fast48h: 'Livraison en moins de 72h !',
        normal48h: 'Livraison rapide sous 48-72h',
        shippingFrom: 'Frais de port : à partir de',
        carrierLabel: 'Transporteur',
        priceLabel: 'Tarif'
      },
      en: {
        open: 'Calculate my shipping costs and delivery time',
        title: 'Shipping costs and delivery time',
        country: 'Country / region',
        calc: 'Calculate',
        loading: 'Calculating...',
        missing: 'Please select a country.',
        noRates: 'No shipping rates available for this address.',
        notCovered: 'Area not covered - We do not deliver to this region at the moment.',
        error: 'Unable to calculate shipping costs right now.',
        available: 'Available shipping rates for your address:',
        delayLabel: 'Estimated delivery:',
        delayFr: '48h - 72h business days',
        delayEu: '5 to 7 business days',
        fast48h: 'Delivery in less than 72h!',
        normal48h: 'Fast delivery within 48-72h',
        shippingFrom: 'Shipping costs: from',
        carrierLabel: 'Carrier',
        priceLabel: 'Price'
      },
      es: {
        open: 'Calcular mis gastos de envío y plazos de entrega',
        title: 'Cálculo de los gastos de envío y plazos de entrega',
        country: 'País / región',
        calc: 'Calcular',
        loading: 'Calculando...',
        missing: 'Por favor, selecciona un país.',
        noRates: 'No hay tarifas disponibles para esta dirección.',
        notCovered: 'Zona no cubierta - No entregamos en esta región por el momento.',
        error: 'No se pueden calcular los gastos de envío en este momento.',
        available: 'Tarifas disponibles para tu dirección:',
        delayLabel: 'Plazo estimado:',
        delayFr: '48h - 72h días laborables',
        delayEu: '5 a 7 días laborables',
        fast48h: '¡Entrega en menos de 72h!',
        normal48h: 'Entrega rápida en 48-72h',
        shippingFrom: 'Gastos de envío: desde',
        carrierLabel: 'Transportista',
        priceLabel: 'Precio'
      }
    };

    return dict[locale] || dict.en;
  }

  // Récupérer le montant actuel du panier
  async function getCartTotal() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      // Retourner le total en euros (price est en centimes)
      return cart.total_price / 100;
    } catch (error) {
      console.error('Erreur lors de la récupération du panier:', error);
      return 0;
    }
  }

  // Vérifier si la livraison est gratuite
  function isFreeShipping(zone, cartTotal) {
    if (zone === 'FRANCE' && cartTotal >= SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLDS.FRANCE) {
      return true;
    }
    if (zone === 'DOMTOM' && cartTotal >= SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLDS.DOMTOM) {
      return true;
    }
    return false;
  }

  // Obtenir les tarifs pour une zone
  function getRatesForZone(zone, cartTotal) {
    // Zone non couverte
    if (zone === 'NOT_COVERED') {
      return null;
    }
    
    // Vérifier si livraison gratuite
    const freeShipping = isFreeShipping(zone, cartTotal);
    
    // Récupérer les tarifs configurés
    let rates = SHIPPING_CONFIG.RATES[zone] || [];
    
    // Appliquer la livraison gratuite si applicable
    if (freeShipping) {
      rates = rates.map(rate => ({
        ...rate,
        price: 0,
        originalPrice: rate.price
      }));
    }
    
    return rates;
  }

  function isWorkingDay(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  }

  function getMarketingMessage() {
    const now = new Date();
    const hour = now.getHours();
    const beforeFive = hour < 5;
    const workingDay = isWorkingDay(now);
    const tr = getTranslations();

    if (beforeFive && workingDay) {
      return {
        text: tr.fast48h,
        highlight: true
      };
    }

    return {
      text: tr.normal48h,
      highlight: false
    };
  }

  function getDelayText(countryCode) {
    const tr = getTranslations();

    if (countryCode === 'FR') {
      return `${tr.delayLabel} ${tr.delayFr}`;
    }

    // Tous les pays hors France : 5 à 7 jours ouvrés
    return `${tr.delayLabel} ${tr.delayEu}`;
  }

  function formatMoney(amount, currency = 'EUR') {
    try {
      return new Intl.NumberFormat(getLocale(), {
        style: 'currency',
        currency
      }).format(amount);
    } catch (e) {
      return `${amount.toFixed(2)} €`;
    }
  }

  function getCountryOptions() {
    // Utiliser les pays disponibles depuis Shopify
    const countries = window.shopifyAvailableCountries || [];
    
    console.log('Pays disponibles depuis Shopify:', countries.length > 0 ? countries : 'Aucun - utilisation de la liste de secours');
    
    // Si aucun pays n'est disponible, utiliser une liste de secours
    if (countries.length === 0) {
      return [
        ['FR', 'France'],
        ['BE', 'Belgique / Belgium'],
        ['ES', 'España / Spain'],
        ['DE', 'Deutschland / Germany'],
        ['IT', 'Italia / Italy'],
        ['NL', 'Nederland / Netherlands'],
        ['PT', 'Portugal'],
        ['LU', 'Luxembourg'],
        ['IE', 'Ireland'],
        ['AT', 'Austria']
      ].map(([value, label]) => {
        return `<option value="${value}">${label}</option>`;
      }).join('');
    }
    
    // Trier les pays par ordre alphabétique
    const sortedCountries = [...countries].sort((a, b) => a.name.localeCompare(b.name));
    
    // Utiliser les pays depuis Shopify
    return sortedCountries.map(country => {
      return `<option value="${country.code}">${country.name}</option>`;
    }).join('');
  }

  function buildWidgetHTML() {
    const tr = getTranslations();

    return `
      <div class="v1-shipping-estimator">
        <button type="button" class="v1-shipping-estimator__open" data-estimator-open>
          <span class="v1-shipping-estimator__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M3 7.75C3 6.7835 3.7835 6 4.75 6H13.25C14.2165 6 15 6.7835 15 7.75V14.25C15 15.2165 14.2165 16 13.25 16H4.75C3.7835 16 3 15.2165 3 14.25V7.75Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
              <path d="M15 9H18.2C18.7021 9 19.1727 9.24136 19.4657 9.64868L21.2657 12.1513C21.4874 12.4594 21.6066 12.8295 21.6066 13.209V14.25C21.6066 15.2165 20.8231 16 19.8566 16H15V9Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
              <path d="M7.25 18.5C8.49264 18.5 9.5 17.4926 9.5 16.25C9.5 15.0074 8.49264 14 7.25 14C6.00736 14 5 15.0074 5 16.25C5 17.4926 6.00736 18.5 7.25 18.5Z" stroke="currentColor" stroke-width="1.8"/>
              <path d="M17.75 18.5C18.9926 18.5 20 17.4926 20 16.25C20 15.0074 18.9926 14 17.75 14C16.5074 14 15.5 15.0074 15.5 16.25C15.5 17.4926 16.5074 18.5 17.75 18.5Z" stroke="currentColor" stroke-width="1.8"/>
            </svg>
          </span>
          <span>${tr.open}</span>
        </button>

        <div class="v1-shipping-estimator__panel" data-estimator-panel hidden>
          <div class="v1-shipping-estimator__head">
            <p class="v1-shipping-estimator__title">${tr.title}</p>
            <button type="button" class="v1-shipping-estimator__close" data-estimator-close aria-label="Close">×</button>
          </div>

          <div class="v1-shipping-estimator__field">
            <label>${tr.country}</label>
            <select data-estimator-country>
              ${getCountryOptions()}
            </select>
          </div>

          <button type="button" style="padding: 6px 12px !important;" class="v1-shipping-estimator__submit button button--card" data-estimator-submit>
            ${tr.calc}
          </button>

          <div class="v1-shipping-estimator__result" data-estimator-result></div>
        </div>
      </div>
    `;
  }

  function renderMessage(resultBox, type, html) {
    resultBox.innerHTML = `<div class="v1-shipping-estimator__message v1-shipping-estimator__message--${type}">${html}</div>`;
  }

  async function buildResultHTML(countryCode) {
    const tr = getTranslations();
    const delayText = getDelayText(countryCode);
    const cartTotal = await getCartTotal();
    const zone = getShippingZone(countryCode);
    const rates = getRatesForZone(zone, cartTotal);

    console.log('=== CALCUL LIVRAISON ===');
    console.log('Pays:', countryCode, '| Zone:', zone);
    console.log('Montant panier:', cartTotal, '€');
    console.log('Tarifs calculés:', rates);

    // Zone non couverte
    if (zone === 'NOT_COVERED' || !rates) {
      return `
        <div class="v1-shipping-estimator__not-covered">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
          <p>${tr.notCovered}</p>
        </div>
      `;
    }

    // Vérifier si livraison gratuite
    const freeShipping = isFreeShipping(zone, cartTotal);

    // Si livraison gratuite
    if (freeShipping) {
      return `
        <div class="v1-shipping-estimator__result-inner">
          <div class="v1-shipping-estimator__free-shipping">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 11l3 3L22 4"></path>
              <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
            </svg>
            <p class="v1-shipping-estimator__free-title">Livraison gratuite 🎉</p>
            <p class="v1-shipping-estimator__free-subtitle">Votre commande bénéficie de la livraison offerte</p>
          </div>
          <div class="v1-shipping-estimator__marketing">
            ${delayText}
          </div>
        </div>
      `;
    }

    // Générer les lignes du tableau
    const tableRows = rates.map(rate => {
      return `
        <tr>
          <td class="v1-shipping-estimator__table-name">${rate.name}</td>
          <td class="v1-shipping-estimator__table-price">${formatMoney(rate.price)}</td>
        </tr>
      `;
    }).join('');

    // Message pour informer du seuil de livraison gratuite
    let thresholdMessage = '';
    if (zone === 'FRANCE') {
      const remaining = SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLDS.FRANCE - cartTotal;
      if (remaining > 0) {
        thresholdMessage = `<p class="v1-shipping-estimator__threshold">Plus que ${formatMoney(remaining)} pour la livraison gratuite !</p>`;
      }
    } else if (zone === 'DOMTOM') {
      const remaining = SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLDS.DOMTOM - cartTotal;
      if (remaining > 0) {
        thresholdMessage = `<p class="v1-shipping-estimator__threshold">Plus que ${formatMoney(remaining)} pour la livraison gratuite !</p>`;
      }
    }

    return `
      <div class="v1-shipping-estimator__result-inner">
        
        ${thresholdMessage}
        
        <table class="v1-shipping-estimator__table">
          <thead>
            <tr>
              <th>${tr.carrierLabel}</th>
              <th>${tr.priceLabel}</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>

        <div class="v1-shipping-estimator__marketing">
          ${delayText}
        </div>

      </div>
    `;
  }

  function initEstimator(container) {
    if (!container || container.dataset.estimatorMounted === 'true') return;

    container.dataset.estimatorMounted = 'true';
    container.innerHTML = buildWidgetHTML();

    const openBtn = container.querySelector('[data-estimator-open]');
    const closeBtn = container.querySelector('[data-estimator-close]');
    const panel = container.querySelector('[data-estimator-panel]');
    const submitBtn = container.querySelector('[data-estimator-submit]');
    const countryField = container.querySelector('[data-estimator-country]');
    const resultBox = container.querySelector('[data-estimator-result]');

    openBtn.addEventListener('click', () => {
      panel.hidden = !panel.hidden;
    });

    closeBtn.addEventListener('click', () => {
      panel.hidden = true;
    });

    submitBtn.addEventListener('click', async () => {
      const countryCode = (countryField.value || '').trim();
      const tr = getTranslations();

      if (!countryCode) {
        renderMessage(resultBox, 'error', `<p>${tr.missing}</p>`);
        return;
      }

      console.log('=== NOUVEAU CALCUL ===');
      console.log('Pays sélectionné:', countryCode);

      // Effacer l'ancien résultat
      resultBox.innerHTML = '';
      renderMessage(resultBox, 'loading', `<p>${tr.loading}</p>`);

      try {
        // Utiliser les tarifs en dur configurés
        const resultHTML = await buildResultHTML(countryCode);
        const zone = getShippingZone(countryCode);
        
        if (zone === 'NOT_COVERED') {
          renderMessage(resultBox, 'not-covered', resultHTML);
        } else {
          renderMessage(resultBox, 'success', resultHTML);
        }
      } catch (error) {
        console.error('Erreur lors du calcul:', error);
        renderMessage(resultBox, 'error', `<p>${tr.error}</p>`);
      }
    });
  }

  function mountEstimator() {
    const container = document.getElementById('v1-calculFDP');
    if (!container) return;
    initEstimator(container);
  }

  document.addEventListener('DOMContentLoaded', mountEstimator);

  const observer = new MutationObserver(() => {
    mountEstimator();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


  }, 1500);

  // ============================================
  // GESTION DES COULEURS POUR LES PROPRIÉTÉS CUSTOM
  // ============================================
  
  // Fonction pour calculer la luminosité d'une couleur hex
  function getLuminance(hex) {
    // Convertir hex en RGB
    const rgb = hex.replace('#', '').match(/.{2}/g).map(x => parseInt(x, 16) / 255);
    
    // Calculer la luminosité relative
    const [r, g, b] = rgb.map(val => {
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }
  
  // Fonction pour déterminer la couleur de texte basée sur la luminosité du fond
  function getContrastColor(bgColor) {
    if (!bgColor || !bgColor.startsWith('#')) {
      return '#ffffff';
    }
    
    const luminance = getLuminance(bgColor);
    return luminance > 0.5 ? '#0D3B26' : '#ffffff';
  }
  
  function generateColorFromString(str) {
    // Hash simple de la chaîne
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Générer une teinte (0-360) basée sur le hash
    const hue = Math.abs(hash % 360);
    
    // Saturation élevée pour des couleurs vives (60-80%)
    const saturation = 60 + (Math.abs(hash) % 20);
    
    // Luminosité moyenne pour garantir la lisibilité (45-65%)
    const lightness = 45 + (Math.abs(hash >> 8) % 20);
    
    const bgColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    
    // Déterminer la couleur du texte en fonction de la luminosité
    const textColor = lightness > 55 ? '#0D3B26' : '#ffffff';
    
    return {
      background: bgColor,
      color: textColor,
      border: bgColor
    };
  }
  
  function applyCustomBadgeColors() {
    // Sélectionner tous les badges custom qui n'ont pas encore été stylés
    const customBadges = document.querySelectorAll('.c-card-product__badge--custom[data-property-slug]:not([data-styled])');
    
    customBadges.forEach(badge => {
      const customColor = badge.getAttribute('data-custom-color');
      const propSlug = badge.getAttribute('data-property-slug');
      
      let colors;
      
      if (customColor && customColor.trim() !== '') {
        // Utiliser la couleur personnalisée définie par le client
        const bgColor = customColor.trim();
        colors = {
          background: bgColor,
          color: getContrastColor(bgColor),
          border: bgColor
        };
      } else if (propSlug) {
        // Générer automatiquement une couleur basée sur le slug
        colors = generateColorFromString(propSlug);
      }
      
      if (colors) {
        badge.style.backgroundColor = colors.background;
        badge.style.color = colors.color;
        badge.style.border = `1px solid ${colors.border}`;
        badge.setAttribute('data-styled', 'true'); // Marquer comme stylé
      }
    });
  }
  
  // Appliquer les couleurs au chargement initial
  applyCustomBadgeColors();
  
  // Observer les changements DOM pour les produits ajoutés dynamiquement
  const badgeObserver = new MutationObserver(() => {
    applyCustomBadgeColors();
  });
  
  badgeObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

});

(function(){function i(){var o=document.getElementById("overlay");var ds=document.querySelectorAll(".menu-bottom details.megamenu-open");if(!ds.length||document.querySelector(".header").getAttribute("data-ux")=="click")return;ds.forEach(function(d){var t;d.onmouseover=function(){clearTimeout(t);if(d.hasAttribute("open"))return;t=setTimeout(function(){ds.forEach(function(x){if(x!==d){x.classList.remove("active");x.removeAttribute("open")}});d.classList.add("active");d.setAttribute("open","true");if(o)o.classList.add("open")},250)};d.onmouseout=function(e){if(e.relatedTarget&&d.contains(e.relatedTarget))return;clearTimeout(t);t=setTimeout(function(){d.classList.remove("active");d.removeAttribute("open");if(o&&!document.querySelector(".menu-bottom details.megamenu-open[open]"))o.classList.remove("open")},350)}})}if(document.readyState=="loading"){document.addEventListener("DOMContentLoaded",i)}else{i()}})();
(function(){function p(){document.querySelectorAll(".menu-bottom .nav-tile img[loading=lazy]").forEach(function(i){i.loading="eager"})}var m=document.querySelector(".menu-bottom");if(m)m.addEventListener("mouseenter",p,{once:true});window.addEventListener("load",function(){if(window.requestIdleCallback){requestIdleCallback(p,{timeout:3000})}else{setTimeout(p,1500)}})})();